export const SUPPORT_PHONE_DISPLAY = '+91-92204 72227';
export const SUPPORT_PHONE_TEL = '+919220472227';
export const SUPPORT_EMAIL = 'info@truehospitals.com';

/** Google Play Data safety — public account deletion page */
export const DELETE_ACCOUNT_PATH = '/patient-loyalty/delete-account';
